<section class="section-recent-news">
  <div class="container text-center">
    <h2 class="title">¿Qué estás esperando para probar todo nuestro menú?</h2>
    <p class="subtitle">
      Descubrí sabores únicos, combos irresistibles y las mejores hamburguesas
      de la ciudad.
    </p>

    <div class="recent-news-grid">
      <div class="item">
        <img src="assets/images/hamburguesa1.webp" alt="Burger 1" />
      </div>

      <div class="item tilted-right">
        <img src="assets/images/hamburguesa2.webp" alt="Burger 2" />
      </div>
    </div>

    <button mat-button class="btn-menu" (click)="irAlMenu()">IR AL MENU</button>
  </div>
</section>
